"use client";

import React, { createContext, useContext, useMemo, useState } from "react";
import { Message } from "@/lib/core/crm/types";

interface ReplyContextType {
  replyingToMessage: Message | null;
  setReplyingToMessage: (message: Message | null) => void;
}

const ReplyContext = createContext<ReplyContextType | undefined>(undefined);

export function ReplyProvider({ children }: { children: React.ReactNode }) {
  const [replyingToMessage, setReplyingToMessage] = useState<Message | null>(null);

  // `setReplyingToMessage` is the useState setter and is already stable, so the
  // value identity changes only when the message actually changes.
  const value = useMemo<ReplyContextType>(
    () => ({ replyingToMessage, setReplyingToMessage }),
    [replyingToMessage]
  );

  return (
    <ReplyContext.Provider value={value}>
      {children}
    </ReplyContext.Provider>
  );
}

export function useReplyContext() {
  const context = useContext(ReplyContext);
  if (!context) {
    throw new Error("useReplyContext must be used within a ReplyProvider");
  }
  return context;
}
